import { useQuery } from '@tanstack/react-query'
import { apis } from '@/modules/apiClients'
import { organizationsQueryKeys } from '@/storeHooks/useOrganizations'

export const useOrganization = (organizationId: string | undefined) => {
    const { data: organizationResponse, isLoading } = useQuery({
        queryKey: organizationsQueryKeys.detail(organizationId || ''),
        queryFn: async () => {
            if (!organizationId) throw new Error('Organization ID is required')
            return await apis.partnerService.organizationsOrganizationIdGet(organizationId)
        },
        enabled: !!organizationId,
        staleTime: 5 * 60 * 1000, // 5 minutes
    })

    return {
        organization: organizationResponse?.data.data,
        isLoading,
    }
}

